import { useEffect } from 'react';

import { useCredentialsWebSockets } from './useCredentialsWebSockets';

/**
 * Hook that stops listening to user:cache:invalidate WS event and adds it again after the component unmounts.
 */
export const usePauseCredentialsWebSocketsListener = () => {
	const { removeCredentialsWebSocketsListener, resetCredentialsWebSocketsListener } = useCredentialsWebSockets();

	useEffect(() => {
		removeCredentialsWebSocketsListener();

		return () => {
			resetCredentialsWebSocketsListener();
		};
	}, []);
};
